import { getFromLocalStorage, LS_KEYS, parseStringifiedValue } from '../../helpers/window';
import { HomeProps } from '../../components/homepage/types';

export interface AudiencesData {
  type: string | null | undefined;
}

/**
 *
 * @param audienceType audience type per loggedin user's industry
 * @param allHomepages all homepage records in contentful of content-type homepage
 * @returns only matching homepage record for audience
 */

export const getHomepageDataForAudience = (
  audienceType: string | undefined,
  allHomepages: HomeProps[],
  /**
   * Since we get from Contentful a string with comma separated audiences,
   * we have to split it and get the first value.
   * We are planning to operate multiple audiences in the future.
   * TODO: change the condition for undefiend to no_audience once the Contentful Audience APP is updated.
   */
): HomeProps => {
  const normalizedTarget = audienceType?.trim().toLowerCase() ?? '';

  // Helper to get normalized first segment from homepage audience type
  const getNormalizedFirstSegment = (homepage: HomeProps): string => homepage.audienceType?.split(',')[0].trim().toLowerCase() ?? '';

  // First try to find an exact normalized match for non-default audience types
  if (normalizedTarget !== '') {
    const exactMatch = allHomepages.find((homepage) =>
      getNormalizedFirstSegment(homepage) === normalizedTarget);
    if (exactMatch) return exactMatch;
  }

  // Then try to find a normalized default match (empty/undefined/no_audience)
  // Prefer entries with non-empty sections
  const defaultMatches = allHomepages.filter((homepage) =>
    getNormalizedFirstSegment(homepage) === '');

  const defaultWithSections = defaultMatches.find((homepage) =>
    homepage.sections && homepage.sections.length > 0);
  if (defaultWithSections) return defaultWithSections;

  const anyDefault = defaultMatches[0];
  if (anyDefault) return anyDefault;

  // Finally, return the first homepage as a fallback to prevent undefined errors
  return allHomepages[0] || {
    contentful_id: '',
    node_locale: '',
    sections: [],
  };
};

/**
 *
 * @param accountId customer id from customer slice/ redux store
 * @returns returns userId either from LS or Customer Slice, which one is available
 */
export const isRecognizedUser = (accountId?: string): boolean => {
  let ajsUserId: string | null = parseStringifiedValue(getFromLocalStorage(LS_KEYS.AJS_USER_ID));
  ajsUserId = ajsUserId === 'null' ? null : ajsUserId;
  const userId = ajsUserId || accountId;
  return !!userId;
};
